<div class="control-groups">
	<app-a3i-wizard-icon *ngIf="showA3iWizard"></app-a3i-wizard-icon>
	<app-address-manage-tool *ngIf="showAddressManage" style="margin-right:4px;" [ngClass]="{'test-check': checkMapEditToggleEnabled()}"></app-address-manage-tool>
	<app-edit-wizard-icon *ngIf="showAddressRelocate"></app-edit-wizard-icon>
	<app-tool-line-split *ngIf="showSplitTool"></app-tool-line-split>
	<app-tool-line-merge *ngIf="showMergeTool"></app-tool-line-merge>
	<div *ngIf="showFlipRoad">
		<app-button-flip-road title="Reverse direction" (click)="clickFlipRoad()"></app-button-flip-road>
	</div>
	<div *ngIf="showSsapLinkButton&&false" class="ssap-rcl-toggle" title="SSAP-RCL Link">
		<label>AC Link</label>
		<input name="ssapRcl" type="checkbox" [(ngModel)]="isSsapRclModeOn" (ngModelChange)="toggleAddressesOnRoadMode()">
	</div>

	<app-line-geom-edit-wizard-icon *ngIf="showLineGeomEditWizard"></app-line-geom-edit-wizard-icon>
	<app-boundary-geom-edit-icon *ngIf="showBdryEditWizard"></app-boundary-geom-edit-icon>
	<!-- <div *ngIf="showEditBtn&&false" class="edit-control">
		<button class="plain-button" [title]="mapEditDisableReason" [ngClass]="{'disabled-icon': !checkMapEditToggleEnabled()}" (click)="toggleMapEditing()">
			{{isMapEditing ? 'End Edit' : 'Begin Edit'}}
			<i class="glyphicons glyphicons-pencil"></i>
		</button>

		<ng-container *ngIf="showTopoModeToggle">
			<mat-icon class="icon-general" svgIcon="icon-topology-ring" [ngClass]="{'icon-off': !isNetworkTopoOn}" (click)="toggleNetworkTopoMode()"></mat-icon>
		</ng-container>
		<div *ngIf="showAddBtn&&showEditBtn&&mapType==='data'" class="map-icon icon-general">
			<i title="Add" class="glyphicons glyphicons-plus" (click)="add()"></i>
		</div>
	</div> -->
	<div *ngIf="showLabelPainter" class="label-controls">
		<mat-icon class="icon-general" svgIcon="icon-label" [ngClass]="{'icon-off': isLabelPainterDisabled}" style="padding:0px;" matTooltip="Draw label for selected roads" (click)="clickLabelPainter()"></mat-icon>
	</div>
	<!-- <div *ngIf="showInteractiveFishbone&&mapType==='data'" class="map-icon fishbone-controls">
		<mat-icon class="icon-general" svgIcon="icon-fishbone" [ngClass]="{'icon-off': isInteractiveFishboneDisabled}" matTooltip="Draw fishbone for the selected road centerline" (click)="clickSingleFishbone()"></mat-icon>
	</div> -->
</div>